import React from "react";
// import HttpService from '../utils/Http.services';
// import { siteConfig, siteTheme } from "../variables/config";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../stores/actionsList';
// import TabBar from "../views/TabBar";
import Configurer from "../components/Configurer";
import Dashboard from "./profile/Dashboard";
import StagesManager from "../components/StagesManager";
import { checkTranslation, pathMaker } from "../utils/useful";
import EditProfile from "./profile/EditProfile";
import Cookies from "universal-cookie";
import PageStatusViewer from "../components/PageStatusViewer";
import AccountType from "./profile/AccountType";
import ChangePasword from "./profile/ChangePasword";
import Financial from "./profile/Financial";
import Modal from "../components/Modal";
import Addresses from "./profile/Financial";
import Wallet from "./profile/Wallet";
// import { logoutUser } from "../stores/actionsList";


class Profile extends React.Component {

    state = {
        pages: [
            { name: '{{lang}}Profile', icon: '/images/man.svg', key: '', dontShowInDashboard: true },
            { name: 'Edit Profile', icon: '/images/edit-profile.svg', key: 'edit' },
            // { name: 'Financial', icon: '/images/benefit.svg', key: 'financial' },


            // { name: 'Wallet', icon: '/images/wallet.svg', key: 'wallet' },

            // { name: 'Addresses', icon: '/images/placeholder.svg', key: 'addresses' },

            // { name: 'Account type', icon: 'https://www.flaticon.com/svg/static/icons/svg/744/744922.svg', key: 'type' },
            { name: 'Change Password', icon: '/images/password.svg', key: 'password' },


        ]
    }


    componentDidMount() {

        const cookies = new Cookies();
        let token = cookies.get('admintoken');
        if (token) {
            this.setState({ isLoading: true })
            this.waitForId(10)
        } else {
            this.setState({ pageStatus: 401 })
        }

        // setInterval(() => {
        //     // console.log("HERE")
        //     if(this.configurer){
        //         console.log(this.configurer)
        //         console.log(this.configurer.props.settingsInfo)
        //     }
        // }, 2000);

        // if(this.configurer){
        //     console.log(this.configurer)
        //     console.log(this.configurer.settingsInfo)
        // }
    }


    waitForId = (leftAttempt) => {
        if (this.props.user?.info?._id) {
            this.setState({ isLoading: false }, () => {
                this.checkDefaultTab()
            })
        } else {
            setTimeout(() => {
                if (leftAttempt != 0) {
                    this.waitForId(leftAttempt - 1)
                } else {
                    // this.props.actions.logoutUser()
                    this.setState({ pageStatus: 401 })
                }
            }, 500);
        }
    }


    componentDidUpdate(newProps) {
        let windowPath = this.props.location.pathname.split('/')
        windowPath = windowPath[windowPath.length - 1]

        // console.log(windowPath)
        // console.log(this.state.path)
        if (this.state.oldPath && this.state.oldPath != this.props.location.pathname) {
            // console.log("CHANGEEEEE")
            this.setState({ oldPath: this.props.location.pathname }, () => {
                this.checkDefaultTab()
            })
        }
    }



    checkDefaultTab() {

        let def = ''

        let pathname = window.location.pathname.split('/')
        pathname.forEach((path, index) => {
            // console.log(path)
            if (path == 'profile') {
                def = pathname[index + 1]
            }
        });

        let pageIsValid = false

        this.state.pages.forEach(tab => {
            if (tab.key.toLowerCase() === def?.toLowerCase()) {
                pageIsValid = true
            }
        });
        if (!def) {
            def = ''
        }
        // console.log(def)
        if (pageIsValid || def === '') {
            this.setState({ oldPath: this.props.location.pathname, pageStatus: 200 }, () => {
                this.setState({ path: def, }, () => {
                    this.stageManager.changeStage(def, () => {
                        window.scrollTo({ top: 0, behavior: 'smooth' })
                    })
                })

                // this.changePage(def)
                // if (def == '' || !def) {
                // this.stageManager.changeStage('dashboard')
                // this.stageManager.changeStage(def)
                // // this.props.history.push(pathMaker('/profile'))
                // } else {

                //     this.stageManager.changeStage(def)

                // }
            })
        } else {
            this.setState({ pageStatus: 404 })
        }
    }








    changePage = (page) => {
        // console.log("CHANGE PAGE")
        // this.stageManager.changeStage(page)
        // this.stageManager.changeStage(page, () => {
        //     // window.scrollTo(0, 0)
        // })
        let path = pathMaker('/profile/' + page)
        // if (this.props.history.pathname != path) {
        //     this.setState({ path: page }, () => {
        //         // console.log("PUSHHHHH")
        this.props.history.push(path)
        if (this.mobileMenuModal) {
            this.mobileMenuModal.hideModal()
        }
        // })
        // }

        // console.log(path)
        // window.history.pushState(null, null, path);

    }


    setUser = (data) => {
        this.props.actions.setUser(data, null, true)
    }


    addNotif = (options) => {
        this.props.actions.addNotif(options)
    }

    logoutAlert = () => {
        this.logoutModal.showModal()
    }

    logout = () => {
        this.props.actions.logoutUser()
        this.props.history.push(pathMaker('/login'))
        this.logoutModal.hideModal()
    }

    openMobileMenu = () => {
        this.mobileMenuModal.showModal()
    }

    showMenu() {
        return (
            <div>
                <div className="text-center py-3">
                    <img src="/images/male.png" width="90px" style={{ borderRadius: 100 }} />
                    <p className="font-bold mt-2">{this.props.user?.info?.name} {this.props.user?.info?.family}</p>
                    {/* <p className="text-small">Account type</p> */}
                    <button onClick={() => this.logoutAlert()} className="px-3 py-2 mt-1" style={{ borderRadius: 20, backgroundColor: '#677dc420' }}>
                        <p className="text-smaller text-bold text-uppercase" style={{ color: '#677dc4', padding: '0px 30px' }}>Log out</p>
                    </button>
                </div>

{/* 
                <button onClick={() => this.changePage('wallet')} className="text-center py-3 px-2 w-100" style={{ backgroundColor: '#677dc430', borderRadius: 2 }}>
                    <p className="text-bold text-normal" style={{ color: '#677dc4' }}>{this.props.user?.info?.balance ?? 0} Coins</p>
                    <p className="text-smaller text-uppercase text-bold " style={{ color: '#345' }}>Your Balance</p>
                </button> */}

                <div className="">
                    {this.state.pages.map((prop, index) => {
                        return (
                            <button onClick={() => this.changePage(prop.key)} key={index} className={"pageSideOption flexc " + (prop.key == this.state.path ? "selected" : '')}>
                                <img src={prop.icon} width="30px" className="mrd-3" />
                                <p>{checkTranslation(prop.name)}</p>

                            </button>
                        )
                    })}
                </div>

            </div>
        )
    }


    render() {

        return (

            <Configurer
                settingsInfo={{ showFooter: true, showTabBar: true, showHeader: true, headerTitle: "Profile", button: {} }}
                title={"Profile"}
                description={"Profile Description"}
                className="p-0 min-full-height"
                ref={el => this.configurer = el}
            >

                <PageStatusViewer status={this.state.pageStatus}>


                    <div className="row m-0">

                        <div className="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-2 pageSide px-0 d-md-block d-none" >
                            {this.showMenu()}
                        </div>


                        <Modal ref={el => this.mobileMenuModal = el} maxWidth={300}>
                            <div className="pageSide" style={{ backgroundColor: '#fff', borderRadius: 15, padding: '20px 5px 70px 5px' }}>
                                {this.showMenu()}

                            </div>
                        </Modal>


                        <div className="col-12 col-sm-12 col-md-9 col-lg-9 col-xl-10 p-0" >

                            <StagesManager ref={el => this.stageManager = el} >
                                <Dashboard pages={this.state.pages} stage={0} user={this.props.user} openMobileMenu={this.openMobileMenu} stageName={''} changePage={this.changePage} logoutAlert={this.logoutAlert} />
                                <EditProfile pages={this.state.pages} stage={1} user={this.props.user} openMobileMenu={this.openMobileMenu} setUser={this.setUser} addNotif={this.addNotif} stageName={'edit'} />
                                <Financial pages={this.state.pages} stage={2} user={this.props.user} openMobileMenu={this.openMobileMenu} stageName={'financial'} />
                                <Addresses pages={this.state.pages} stage={2} user={this.props.user} openMobileMenu={this.openMobileMenu} stageName={'addresses'} />
                                <Wallet pages={this.state.pages} stage={2} user={this.props.user} openMobileMenu={this.openMobileMenu} stageName={'wallet'} />

                                <ChangePasword pages={this.state.pages} stage={3} user={this.props.user} openMobileMenu={this.openMobileMenu} addNotif={this.addNotif} stageName={'password'} />

                            </StagesManager>

                        </div>
                    </div>

                </PageStatusViewer>

                <Modal maxWidth={350} ref={el => this.logoutModal = el}>
                    <div className="text-center" style={{ backgroundColor: '#fff', borderRadius: 8, padding: '30px' }}>
                        <p className="text-big text-bold">Log out</p>
                        <p className="text-small">Are you sure you want to log out?</p>

                        <div className="flexcc mt-3">
                            <button onClick={() => this.logout()} className="px-4 py-2 white text-bold text-small" style={{ backgroundColor: '#ee5050', borderRadius: 30 }}>LOG OUT</button>
                            <button onClick={() => this.logoutModal.hideModal()} className="px-4 py-2 text-small" style={{ backgroundColor: '#e2e8f2', borderRadius: 30 }}>Cancel</button>
                        </div>

                    </div>
                </Modal>

            </Configurer>
        )


    }


}



const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Profile);
